<div class="table-total-depth">
      <div class="depth rounded">
            <p class="titledepth text-left">{{ "depth-total" | lang | uppercase }}</p>
            <p class="subtitle-depth text-right">{{ quantityDepth }}</p>
      </div>

      <div class="depth rounded depth-bottom">
            <p class="titledepth text-left">
                  {{ "depth_quantity" | lang | uppercase }}
            </p>
            <p class="subtitle-depth text-right">{{ totalDepth }}</p>
      </div>
</div>
